<template>
  <TeaserAccountTile>
    <template #component>
      <UpgradeIdLevel></UpgradeIdLevel>
    </template>
    <template #image>
      <TeaserIdLevelUpgrade></TeaserIdLevelUpgrade>
    </template>
  </TeaserAccountTile>
</template>

<script setup lang="ts">
import TeaserAccountTile from '@/components/rahmen/TeaserAccountTile.vue'
import UpgradeIdLevel from '@/components/account-management/idlevelupgrade/UpgradeIdLevel.vue'
import TeaserIdLevelUpgrade from '@/componentsTenant/rahmen/images/TeaserIdLevelUpgrade.vue'
</script>
